module.exports = __webpack_public_path__ + "static/media/fokus.cab30e7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/fokus.jpg
// module id = 849
// module chunks = 7